export default {"src":"/_next/static/media/black_star.4d445354.svg","height":10,"width":11};